import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { RecueilGridComponent } from '../../ui/recueil-grid/recueil-grid.component';
import { AppPageBase, BreadcrumbComponent, BreadcrumbService, RecueilService } from '@lyricstream/shared';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-recueils',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, BreadcrumbComponent, RecueilGridComponent, TranslateModule],
  templateUrl: './recueils.html',
  styleUrl: './recueils.scss',
})
export class RecueilsComponent extends AppPageBase implements OnInit {
  //protected readonly lang          = inject(LANG_SIGNAL);
  // Préfixe d'URL actif (recueils ou groupe-ce) : les liens restent sous la même URL
  protected readonly basePath      = inject(ActivatedRoute).snapshot.parent?.url[0]?.path ?? this.routeName.Recueils;
  protected readonly recueilService = inject(RecueilService);
  private  readonly breadcrumbService = inject(BreadcrumbService);
  private  readonly translate = inject(TranslateService);

  protected readonly recueils = this.recueilService.recueils;
  protected readonly loading  = this.recueilService.loading;
  protected readonly error    = this.recueilService.error;

  constructor() {
    super();
    // Fil d'Ariane traduit, remis à jour à chaque changement de langue
    this.translate
      .stream(['RECUEILS.BREADCRUMB.DISCOVER', 'RECUEILS.BREADCRUMB.RECUEILS'])
      .pipe(takeUntilDestroyed(inject(DestroyRef)))
      .subscribe((t) => this.breadcrumbService.set([
        { label: t['RECUEILS.BREADCRUMB.DISCOVER'], routerLink: ['/', this.lang(), this.routeName.Discover] },
        { label: t['RECUEILS.BREADCRUMB.RECUEILS'] },
      ]));
  }

  ngOnInit(): void {
    this.recueilService.getRecueilsActive();
  }

}
